import {
  Box,
  Button,
  Dialog,
  Icon,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";

import successIcon from "../../images/dialogs/success.png";
import erroIcon from "../../images/dialogs/error.png";
import warningIcon from "../../images/dialogs/warning.png";
import defaultIcon from "../../images/dialogs/default.png";

import { ThemeProvider, createTheme, ThemeOptions } from "@mui/material/styles";
import { Close } from "@mui/icons-material";
import { useEffect, useState } from "react";

const themeSucess = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#3AB238",
    },
    secondary: {
      main: "#0D650C",
    },

    text: {
      primary: "#0d650c",
      secondary: "#0d650c",
    },
  },
});

const themeError = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#D92424",
    },
    secondary: {
      main: "#8A0202",
    },

    text: {
      primary: "#8A0202",
      secondary: "#8A0202",
    },
  },
});
const themeWarning = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#FC8618",
    },
    secondary: {
      main: "#D56804",
    },

    text: {
      primary: "#D56804",
      secondary: "#D56804",
    },
  },
});

const themeDefault = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#3E94C2",
    },
    secondary: {
      main: "#1E729F",
    },

    text: {
      primary: "#1E729F",
      secondary: "#1E729F",
    },
  },
});

const styles = {
  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alingItems: "center",
    gap: "10px",
    padding: "4rem 2rem",
  },
  topBar: {
    display: "flex",
    color: "#ffffff",
    height: "56px",
    alingItems: "center",
    justifyContent: "space-between",
    padding: "8px 16px",
  },
  closeIcon: { color: "#ffffff", width: "24px", height: "auto" },
  icon: {
    width: "100%",
    height: "80px",
  },
  subTitle: {
    fontSize: "1.6rem",
    textAlign: "center",
    alingItems: "center",
    fontWeight: 500,
  },
  text: { textAlign: "center", alingItems: "center", fontSize: "1.2rem" },
  button: { color: "#ffffff" },
};

export default function DialogSuccess(props) {
  const {
    subTitle = "",
    text = "",
    buttonAcceptText = "Button",
    buttonRejectText = "Button",
    variant,
    open,
    onClose,
  } = props;

  const [theme, setTheme] = useState(themeDefault);
  const [diologIcon, setDiologIcon] = useState(defaultIcon);
  const [topBarColor, setTopBarColor] = useState("#3E94C2");
  const [topBarText, setTopBarText] = useState("");

  useEffect(() => {
    if (variant == "success") {
      setTheme(themeSucess);
      setTopBarColor("#3AB238 !important");
      setDiologIcon(successIcon);
      setTopBarText("Sucesso");
    }

    if (variant == "error") {
      setTheme(themeError);
      setTopBarColor("#D92424 !important");
      setDiologIcon(erroIcon);
    }
    if (variant == "warning") {
      setTheme(themeWarning);
      setTopBarColor("#FC8618 !important");
      setDiologIcon(warningIcon);
    }
    if (variant == "default") {
      setTheme(themeDefault);
      setTopBarColor("#1E729F !important");
      setDiologIcon();
      setTopBarText("Inativar vínculo");
    }
  }, []);

  return (
    <>
      <ThemeProvider theme={theme}>
        <Dialog open={open} onClose={() => onClose(false)}>
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              flexDirection: "column",
              overflowX: "hidden",
              width: "fit-content",
            }}
          >
            <Box sx={styles.topBar} backgroundColor={topBarColor}>
              <Typography
                fontSize={"26px"}
                fontWeight={"600"}
                fontFamily={"Nunito"}
              >
                {topBarText}
              </Typography>
              <IconButton onClick={() => onClose(false)}>
                <Close sx={styles.closeIcon} />
              </IconButton>
            </Box>

            <Box
              sx={{
                ...styles.content,
                maxWidth: "400px",
                minWidth: "340px",
                width: { xs: "100%", sm: "400px" },
                boxSizing: "border-box",
              }}
            >
              {variant == "default" ? (
                <></>
              ) : (
                <Icon style={styles.icon}>
                  <img src={diologIcon} />
                </Icon>
              )}

              <Box sx={styles.subTitle}>{subTitle}</Box>
              <Box sx={styles.text}>{text}</Box>
              {buttonRejectText !== "" ? (
                <Box
                  sx={{
                    display: "flex",
                    alingItems: "center",
                    justifyContent: "end",
                    marginTop: "10px",
                    gap: "1rem",
                  }}
                >
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => onClose(false)}
                  >
                    {buttonRejectText}
                  </Button>
                  <Button
                    color="primary"
                    sx={styles.button}
                    variant={"contained"}
                    onClick={() => onClose(true)}
                  >
                    {buttonAcceptText}
                  </Button>
                </Box>
              ) : (
                <></>
              )}
            </Box>
          </Box>
        </Dialog>
      </ThemeProvider>
    </>
  );
}
